import { Skeleton } from '@kmgestao/ui';

/**
 * Estado de loading da rota `/onboarding/:token`. Skeletons que
 * desenham o shape de um form com 2 seções — evita layout shift
 * quando o dado carrega. Mobile-first, empilhado.
 */
export function OnboardingLoadingState() {
  return (
    <div className="space-y-6" aria-busy="true" aria-live="polite">
      <header className="space-y-2">
        <Skeleton className="h-8 w-3/4" />
        <Skeleton className="h-4 w-1/2" />
      </header>

      <section className="space-y-4 rounded-lg border border-border bg-card p-4 sm:p-6">
        <Skeleton className="h-6 w-1/3" />
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
      </section>

      <section className="space-y-4 rounded-lg border border-border bg-card p-4 sm:p-6">
        <Skeleton className="h-6 w-1/3" />
        <Skeleton className="h-24 w-full" />
        <Skeleton className="h-24 w-full" />
      </section>
    </div>
  );
}
